import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import {useForm} from "react-hook-form";
import {Popover} from "@mui/material";
import {useDebouncedCallback} from "use-debounce";
import {InputMain, MinLoader, TextToolTip} from "components";
import {Svg} from "assets";
import {filterFromTable, limit, SavePage, SaveParams} from "utils";


export const TableHeaderVehicle = ({
                                       width,
                                       item,
                                       loader,
                                       setListInfo,
                                       list,
                                       searched,
                                       setSearched,
                                       generateTable,
                                   }) => {
    const [currentVehicles, setCurrentVehicles] = useState([]);
    const [backSearched, setBackSearched] = useState({
        searchKey: "",
        searchValue: "",
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const {control, setValue, watch} = useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const itemName = item?.name ? item?.name : null
    const active =
        info?.[item?.name] === itemName ? true :
            info?.hasOwnProperty(itemName) ? true :
                info?.sortType === itemName ? true
                    : (searched?.name === itemName && searched?.value) || (backSearched?.searchKey === item?.searchKey && backSearched?.searchValue);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const searchVehicle = watch('vehicle');


    useEffect(() => {
        const vehicles = [
            ...new Map(
                list
                    .filter(leg => leg.vehicle)
                    .map(leg => [leg.vehicle.unitNumber, leg.vehicle])
            ).values(),
        ];

        setCurrentVehicles(vehicles);
    }, [list]);

    useEffect(() => {
        if (searched?.value && searched?.name && (searched?.name === item?.name)) {
            const filtered = filterFromTable(
                {target: {...searched}},
                item?.rowName,
                list
            );
            setListInfo(filtered);
        }

        if (backSearched?.searchValue && backSearched?.searchKey && (backSearched?.searchKey === item?.searchKey)) {
            const filtered = filterFromTable(
                {target: {name: backSearched.searchKey, value: backSearched.searchValue}},
                item?.rowName,
                list
            );
            setListInfo(filtered);
        }
    }, [list, searched, backSearched, item?.rowName]);

    useEffect(() => {
        if (info?.searchKey) {
            setBackSearched({
                searchKey: info?.searchKey,
                searchValue: info?.searchValue,
            });
        } else {
            setBackSearched({
                searchKey: "",
                searchValue: "",
            });
        }
    }, [info]);


    const debounced = useDebouncedCallback(
        (name, value, searchKey) => {
            const params = {
                ...info,
            };
            params.limit = limit;
            params.skip = 0;
            params.page = 1;
            if (value) {
                params.searchKey = searchKey;
                params.searchValue = value;
            } else {
                delete params.searchKey;
                delete params.searchValue;
            }
            SaveParams(location?.pathname, navigate, params);
        },
        1000,
        {maxWait: 2000},
    );

    const handleSearch = (e, nameRow, searchKey, type) => {
        if (searchKey) {
            setBackSearched({
                searchKey: searchKey,
                searchValue: e.target.value,
            });
            debounced(e.target.name, e.target.value, searchKey);
        } else {
            setSearched({
                name: e.target.name,
                value: e.target.value,
            });
            if (e.target.name) {
                if (!e.target.value) {
                    setListInfo(list);
                } else {
                    const info = filterFromTable(e, nameRow, list, type);
                    setListInfo(info);
                }
            }
        }
    };

    const handleClickSort = (name) => {
        if (item?.custom !== false) {
            const anotherInfo = {
                ...info,
            };
            anotherInfo.sortType = name;

            const checkForASC = !anotherInfo?.orderType || (anotherInfo?.orderType && info?.sortType !== name);

            if (checkForASC) {
                anotherInfo.orderType = "ASC";
            } else if (anotherInfo?.orderType === "ASC") {
                anotherInfo.orderType = "DESC";
            } else {
                delete anotherInfo.orderType;
                delete anotherInfo.sortType;
            }
            SavePage(navigate, info, {...anotherInfo});
        }
    };

    const toggleMenu = (event) => {
        event ? setAnchorEl(event?.currentTarget) : setAnchorEl(null);
    };


    const handleSubmit = (event) => {
        event.preventDefault();
    };
    return (
        <div className="search-and-filer-box">
            <div
                className={active ? "active-box" : "passive-box"}
                style={width ? {width: width} : {}}
            >
                <div
                    onClick={() => handleClickSort(item?.name)}
                    className="search-input-title"
                    style={{
                        cursor: item?.custom !== false ? "pointer" : "default",
                        whiteSpace: "nowrap",
                    }}
                >
                    <TextToolTip
                        text={item?.title}
                        content={item?.title}
                        classNameText="search-and-filer-text"
                    />
                    {item?.custom !== false && (
                        <div
                            className={
                                generateTable ? "sort-btn-box-generate" : "sort-btn-box"
                            }
                            style={
                                info?.orderType && info?.sortType === item?.name
                                    ? {opacity: 1}
                                    : {opacity: 0.6}
                            }
                        >
                            {item?.iconType === "date" ? (
                                info?.sortType === item?.name &&
                                info?.orderType === "DESC" ? (
                                    <Svg.LatestEarliestSvg/>
                                ) : (
                                    <Svg.LatestEarliestWhiteSvg/>
                                )
                            ) : info?.sortType === item?.name ?
                                info?.orderType === "DESC" ? (
                                        <Svg.SortSvgDESC/>
                                    )
                                    :
                                    (
                                        <Svg.SortSvgASC/>
                                    )
                                :
                                (
                                    <Svg.SortSvg/>
                                )
                            }
                        </div>
                    )}
                </div>

                <div style={{position: "relative"}}>
                    <form autoComplete="off" onSubmit={handleSubmit}>
                        <input
                            style={{
                                paddingRight: 32
                            }}
                            autoComplete={"new-password"}
                            disabled={item?.disabled || !item?.name}
                            name={item?.name}
                            value={
                                backSearched?.searchKey === item?.searchKey
                                    ? backSearched?.searchValue
                                    : searched?.name === item?.name
                                        ? searched?.value
                                        : ""
                            }
                            onChange={(e) =>
                                handleSearch(e, item?.rowName, item?.searchKey, item?.icon)
                            }
                        />

                        <div
                            style={{
                                height: 'fit-content',
                                position: 'absolute',
                                right: 0,
                                top: 0,
                                bottom: 0,
                                margin: 'auto 0',
                                cursor: 'pointer'
                            }}
                        >
                            {(searched?.value && searched?.name === item?.name) &&
                                <button
                                    className='reset-btn'
                                    style={{
                                        width: 15,
                                        height: 15,
                                    }}
                                    type='button'
                                    onClick={() => {
                                        handleSearch({
                                            target: {
                                                name: item?.name,
                                                value: '',
                                            },
                                        }, item?.rowName, item?.searchKey, item?.icon)
                                    }}
                                >
                                    <Svg.CloseSvg style={{width: "100%", height: "100%"}}/>
                                </button>
                            }

                            {!!currentVehicles?.length &&
                                <button
                                    className='reset-btn'
                                    type='button'
                                    style={{
                                        width: 17,
                                        height: 17,
                                        transform: `${open ? 'rotate(180deg)' : 'rotate(0deg)'} `,
                                    }}
                                    onClick={toggleMenu}
                                >
                                    <Svg.ArrowDownSvg style={{width: "100%", height: "100%"}}/>
                                </button>
                            }
                        </div>
                    </form>

                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={(e) => {
                            e.stopPropagation();
                            toggleMenu()
                        }}
                        className={"assign-vehicle-popper"}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                    >
                        <h1 className='assign-vehicle-title'>
                            Search Vehicle
                        </h1>

                        <InputMain
                            name={`vehicle`}
                            control={control}
                            allowErrorMessage={false}
                        />
                        {!!currentVehicles?.length &&
                            <ul className='assign-vehicle-list-wrapper'>
                                {currentVehicles?.sort((a, b) => a.unitNumber?.localeCompare(b.unitNumber, undefined, { numeric: true }))?.filter((vehicle) => vehicle?.unitNumber?.toString()?.includes(searchVehicle || ''))?.map((vehicle) => (
                                    <li
                                        key={vehicle?.id}
                                        className={`assign-vehicle-list-item ${searched?.value === vehicle?.unitNumber ? 'assign-vehicle-list-item-selected' : ''}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            toggleMenu();
                                            handleSearch({
                                                target: {
                                                    name: item?.name,
                                                    value: vehicle?.unitNumber,
                                                },
                                            }, item?.rowName, item?.searchKey, item?.icon)
                                        }}
                                    >
                                        <TextToolTip
                                            classNameText='assign-vehicle-list-item_text'
                                            content={vehicle?.unitNumber}
                                            text={vehicle?.unitNumber}
                                        />
                                    </li>
                                ))}
                            </ul>
                        }
                    </Popover>
                    {!!loader && (
                        <MinLoader
                            margin={"6px 0 0 -20px"}
                            color="rgba(166, 222, 251, 0.29)"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

